// import "./detail.scss";
import { useTranslation } from "react-i18next";
import { Input, Row, Space } from "antd";
import { useState } from "react";

const QuestionType8 = (props: any) => {
  const { t } = useTranslation();
    const [showPlaceholder, setShowPlaceholder] = useState(true);

    const handleFocus = () => {
        setShowPlaceholder(false);
    };

    const handleBlur = () => {
        setShowPlaceholder(true);
    };

    return (
        <div>
            <div>
                <br />
                <Space direction="vertical" size="small" style={{ display: "flex" }}>
                    <Row
                        style={{
                            margin: "0 auto",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Input
                            style={{ borderTop: "none", borderLeft: "none", borderRight: "none" }}
                            value={t("Nhập câu trả lời của bạn", "Nhập câu trả lời của bạn")}
                        />
                    </Row>
                </Space>
                <br />
            </div>
        </div>
    );
};

export default QuestionType8;
